import Vue from 'vue';

// import {
// 	checkReport
// } from '@/services/clients';

export const globalStore = new Vue({

	data: {
		globalvar: 'global hello world',

		setToken(token) {
			localStorage.setItem('token', token);
		},
		getToken() {
			return localStorage.getItem('token');
		},
		clearToken() {
			return localStorage.removeItem('token');
		},
    setLanguage(language) {
      localStorage.setItem('language', language);
    },
    getLanguage() {
      return localStorage.getItem('language');
    },
    clearLanguage() {
      return localStorage.removeItem('language');
    },
		setUser(user) {
			localStorage.setItem('user', JSON.stringify(user) );
		},
		getUser(){
			return JSON.parse(localStorage.getItem('user'));
		},
		getRole(){
			return JSON.parse(localStorage.getItem('user')).roles[0];
		},
		getId(){
			return JSON.parse(localStorage.getItem('user')).roles[0];
		},
		clearUser() {
			return localStorage.removeItem('user');
		},
		getTeam(){
			return JSON.parse(localStorage.getItem('user'))['teams'][0]['id'];
		},
	}

});

// export const requestJobs = new Vue({
// 	data : {
// 		interval: null,
// 		startJob(name, uuid) {

// 			this.interval = setInterval(() => {

// 				checkReport(uuid)
// 					.then(response => {
// 						if(response.data.status != "pending") {
// 							clearInterval(this.interval);
// 							this.$emit("report-alert", { name : name, uuid : uuid } );
// 							this.$destroy();
// 						}
// 					})
// 					.catch(err =>{
// 						console.log(err);
// 					})

// 			}, 5000);

// 		}
// 	},
// 	mounted() {
// 		clearInterval(this.interval);
// 	},
// 	beforeDestroy: function(){
// 		clearInterval(this.interval);
// 	}
// })



// WEBPACK FOOTER //
// ./src/services/userService.js